import { useEffect } from 'react';
import { createPortal } from 'react-dom';

export default function ConfirmModal({ 
  isOpen, 
  title, 
  message, 
  confirmText = 'Eliminar', 
  cancelText = 'Cancelar', 
  onConfirm, 
  onCancel,
  icon = '⚠️'
}) {
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onCancel();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  return createPortal(
    <div 
      className="modal-overlay animate-fade" 
      style={{ 
        zIndex: 10000, 
        justifyContent: 'center', 
        alignItems: 'center', 
        padding: '16px' 
      }} 
      onClick={(e) => {
        if (e.target.className.includes('modal-overlay')) onCancel();
      }}
    >
      <div 
        className="modal-content animate-scale" 
        style={{ 
          maxWidth: '400px', 
          width: '100%',
          margin: '0 auto', 
          borderRadius: 'var(--radius-lg)', 
          borderBottomLeftRadius: 'var(--radius-lg)',
          borderBottomRightRadius: 'var(--radius-lg)',
          padding: '24px',
          boxShadow: '0 10px 25px rgba(0,0,0,0.5)',
          border: '1px solid rgba(255, 255, 255, 0.08)'
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '16px' }}>
          <span style={{ fontSize: '48px', display: 'block', marginBottom: '8px' }}>{icon}</span>
          <h3 style={{ margin: 0, fontSize: '20px', fontWeight: 'bold', color: 'var(--text-primary)' }}>
            {title}
          </h3>
        </div>

        <p style={{ textAlign: 'center', fontSize: '15px', color: 'var(--text-secondary)', marginBottom: '24px', lineHeight: 1.6 }}>
          {message}
        </p>

        <div style={{ display: 'flex', gap: '12px' }}>
          <button 
            type="button" 
            className="btn-secondary" 
            onClick={onCancel}
            style={{ 
              flex: 1, 
              padding: '12px 16px', 
              fontSize: '14px', 
              borderRadius: 'var(--radius-md)', 
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            {cancelText}
          </button>
          <button 
            type="button" 
            className="btn" 
            onClick={onConfirm}
            style={{ 
              flex: 1, 
              padding: '12px 16px', 
              fontSize: '14px', 
              borderRadius: 'var(--radius-md)', 
              backgroundColor: 'var(--danger-color)', 
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
